const constants = {
  serverURL: process.env.REACT_APP_API_URL || 'https://fluxo-dev.herokuapp.com',
};

Object.freeze(constants);

export default constants;
